/**
 * Local-only history for downloaded ads.
 *
 * Notes on data sensitivity:
 * - Every field stored here is derived from *public* Meta Ad Library data
 *   (page name, ad id, media URLs, source URL). No user credentials, no
 *   personal data, no auth tokens — nothing sensitive.
 * - The tool has no login; there is no server-side account to sync to.
 *   localStorage is the correct storage tier for this use case.
 * - History is scoped to the browser (per-device) and can be cleared at
 *   any time via the UI's "Clear all" control.
 */
const KEY = "adlib_download_history_v1";
const MAX_ENTRIES = 24;

export const getHistory = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const addToHistory = (ad) => {
  const entry = {
    id: ad.id || `${Date.now()}`,
    ad_id: ad.ad_id || null,
    page_name: ad.page_name || null,
    title: ad.title || null,
    preview_image_url: ad.preview_image_url || ad.image_url || null,
    video_hd_url: ad.video_hd_url || null,
    video_sd_url: ad.video_sd_url || null,
    image_url: ad.image_url || null,
    source_url: ad.source_url,
    saved_at: new Date().toISOString(),
  };
  const existing = getHistory().filter(
    (e) => e.ad_id !== entry.ad_id || !entry.ad_id
  );
  const next = [entry, ...existing].slice(0, MAX_ENTRIES);
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
};

export const clearHistory = () => {
  localStorage.removeItem(KEY);
};

export const removeFromHistory = (id) => {
  const next = getHistory().filter((e) => e.id !== id);
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
};
